query GetPersonalizedDemo {
    personalizedDemo {
        salesContactImageUrl
        salesContactType
        salesContactName
        salesContactShortName
        salesContactMeetingId
        instanceId
        salesContactEmail
    }
}
